module.exports = __webpack_public_path__ + "static/media/plus-icon.e01fe56b.svg";